import React, { Component } from "react";
import renderHTML from "react-render-html";
import { WiTime9 } from "react-icons/wi";
import { GiChefToque } from "react-icons/gi";
import data from "../featured";
import defaultImg from "../images/defaultImg.png";

export default class SingleRecipe extends Component {
  state = {
    recipe: {},
  };

  componentDidMount() {
    const { id, name } = this.props.match.params;
    if (id) {
      const apiKey = "9fb5ead2d0c04093b45427060461408b";
      const apiUrl = `https://api.spoonacular.com/recipes/${id}/information?apiKey=${apiKey}`;

      fetch(apiUrl)
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          this.setState({
            recipe: data,
          });
        });
    } else {
      console.log(data);
      const recipe = data.find((item) => item.id === name);
      console.log(recipe);
      this.setState({
        recipe,
      });
    }
  }
  render() {
    const { recipe } = this.state;

    return (
      <div className="singleRecipe">
        <div className="singleRecipe__row1">
          <div className="singleRecipe__row1-col1">
            <img src={recipe.image || defaultImg} alt="" />
          </div>
          <div className="singleRecipe__row1-col2">
            <h2>{recipe.title}</h2>
            <div className="recipe-info">
              <p className="time">
                <WiTime9 /> {recipe.readyInMinutes} mins
              </p>
              <p className="servings">
                <GiChefToque /> {recipe.servings} servings
              </p>
            </div>
            <h4>Ingredients</h4>
            <ul className="ingredients">
              {recipe.extendedIngredients ? (
                recipe.extendedIngredients.map((ingredient) => {
                  return <li>- {ingredient.original}</li>;
                })
              ) : (
                <h1>Loading ...</h1>
              )}
            </ul>
          </div>
        </div>

        <div className="singleRecipe__row2">
          <div className="singleRecipe__row2-col1">
            <h4>Summary</h4>
            <p>
              {recipe.summary ? renderHTML(recipe.summary) : <h4>Loading</h4>}
            </p>
          </div>
          <div className="singleRecipe__row2-col2">
            <h4>Instructions</h4>
            <p className="instructions">
              {recipe.instructions ? (
                renderHTML(recipe.instructions)
              ) : (
                <h1>Loading...</h1>
              )}
            </p>
          </div>
        </div>
      </div>
    );
  }
}
